import { basePath } from "./config";
import { getAdminToken, getCustomerToken } from "./session";

export function debounce(func, delay, timeoutId) {
  return (...args) => {
    if (timeoutId) {
      clearTimeout(timeoutId);
    }
    timeoutId = setTimeout(() => {
      func(...args);
    }, delay);
  };
}

const PAGE_SCROLL_ROOT_SELECTOR =
  ".home-page-container, .about-page-container, .hotels-page-container, .coming-soon-page-container";

/**
 * Public marketing pages scroll inside these wrappers (not `window`).
 * `main.scrollIntoView()` misaligns content under the fixed header—reset explicitly.
 */
export function resetScrollablePageContainers() {
  document.querySelectorAll(PAGE_SCROLL_ROOT_SELECTOR).forEach((el) => {
    el.scrollTop = 0;
  });
  window.scrollTo(0, 0);
  document.documentElement.scrollTop = 0;
  document.body.scrollTop = 0;
}

export const scrollToTop = () => {
  resetScrollablePageContainers();
};

export const generateCredentials = (email, password) => {
  return btoa(`${email}:${password}`);
};

export const generateHeader = () => {
  let credentials = window.location.href.includes("customer")
    ? getCustomerToken()
    : getAdminToken();
  return {
    Authorization: `Basic ${credentials}`,
    "Content-Type": "application/json",
  };
};

export const makeGetCall = async (path) => {
  try {
    const url = `${basePath}/${path}`;
    const res = await fetch(url, {
      method: "GET",
      headers: generateHeader(),
    });
    if (!res.ok) throw new Error(`Failed to fetch data: ${res.status}`);
    const data = await res.json();
    return data;
  } catch (err) {
    console.error("Error fetching data:", err);
    return [];
  }
};

export function formatDuration(ms) {
  const totalSeconds = Math.floor(ms / 1000);

  const days = Math.floor(totalSeconds / 86400);
  const hours = Math.floor((totalSeconds % 86400) / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;

  return {
    days,
    hours,
    minutes,
    seconds,
    text: `${days}d ${hours}h ${minutes}m ${seconds}s`
  };
}
